export default async function CreatePlanLevelApi(
  name,
  color,
  order,
  description,
  tasks,
  kpi,
  target,
  targetDate,
  planAttributes,
  template
) {
  let res = "";
  try {
    const body = {
      name: name,
      color: color,
      order: order,
      description: description,
      tasks: tasks,
      kpi: kpi,
      target: target,
      targetDate: targetDate,
      planAttributes: planAttributes,
      template: template,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plan-levels/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error create plan level: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
